import { render, staticRenderFns } from "./customerService.vue?vue&type=template&id=6e46fd8e&"
import script from "./customerService.vue?vue&type=script&lang=js&"
export * from "./customerService.vue?vue&type=script&lang=js&"
import style0 from "./customerService.vue?vue&type=style&index=0&id=6e46fd8e&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e46fd8e')) {
      api.createRecord('6e46fd8e', component.options)
    } else {
      api.reload('6e46fd8e', component.options)
    }
    module.hot.accept("./customerService.vue?vue&type=template&id=6e46fd8e&", function () {
      api.rerender('6e46fd8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/customerService/customerService.vue"
export default component.exports